import { render, staticRenderFns } from "./sourcingmasterv2.vue?vue&type=template&id=2e2ffa58&scoped=true"
import script from "./sourcingmasterv2.vue?vue&type=script&lang=js"
export * from "./sourcingmasterv2.vue?vue&type=script&lang=js"
import style0 from "./sourcingmasterv2.vue?vue&type=style&index=0&id=2e2ffa58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ffa58",
  null
  
)

export default component.exports